import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { quincyMaConfig } from "./data";

export default function QuincyMaPage() {
  return <CityPageTemplate config={quincyMaConfig} />;
}